import React, { useState } from 'react';
import { ADMIN_PASSWORD } from './constants';

const AdminModal = ({ purpose, onSuccess, onClose }) => {
    const [password, setPassword] = useState('');
    const [error, setError]       = useState('');

    const handleSubmit = () => {
        if (password === ADMIN_PASSWORD) {
            setError('');
            onSuccess(purpose);
        } else {
            setPassword('');
            setError('Mot de passe incorrect, réessayez.');
        }
    };

    const purposeLabel = {
        cancel: 'Annuler le paiement en cours',
    }[purpose] ?? 'Action administrateur';

    return (
        <div className="admin-modal-overlay">
            <div className="admin-modal-window">
                <div className="admin-modal-icon">🔒</div>
                <h3 className="admin-modal-title">Autorisation requise</h3>
                <p className="admin-modal-subtitle">{purposeLabel}</p>

                <input
                    type="password"
                    className="white-input admin-input"
                    placeholder="Mot de passe administrateur"
                    value={password}
                    onChange={e => { setPassword(e.target.value); setError(''); }}
                    onKeyDown={e => e.key === 'Enter' && handleSubmit()}
                    autoFocus
                />

                {error && <p className="admin-error">{error}</p>}

                <div className="admin-modal-actions">
                    <button
                        className="pill-btn blue"
                        onClick={handleSubmit}
                        disabled={!password}
                    >
                        Confirmer
                    </button>
                    <button className="pill-btn outline" onClick={onClose}>
                        Annuler
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AdminModal;